import axios from 'axios'

const api = axios.create({
  baseURL: "https://contadigitalbk.euquerograna.com.br",
  // baseURL: "http://127.0.0.1:8002/",
  responseType: "json",
})

export default api